import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void) {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
}

/**
 * Whether the browser believes it has a connection — `navigator.onLine` plus the `online`/`offline`
 * events. The offline criteria across 113584 §14, 113586 §15d and 113588 §15 all branch on this.
 *
 * `useSyncExternalStore` rather than an effect and a `useState`: the browser already owns this
 * value, so mirroring it into React state would give a first render that reports `true` on a machine
 * that is offline. The server snapshot is `true` because there is no such thing as an offline SSR
 * render, and this app is CSR-only anyway.
 *
 * No consumer yet — tickets 12 and 14 are the first. Landed here because this ticket lays the
 * scaffolding every later one stands on.
 */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );
}
